import { writable } from 'svelte/store';

const wpn2SchemaData = writable({
    entityInfo: {},
    keysList: [{}],
});

const schemaData = {
    subscribe: wpn2SchemaData.subscribe,
    importSchema: (data) => {
        wpn2SchemaData.update((sData) => {
            sData.entityInfo = data;
            sData.keysList = schemaData.allKeys(data);
            return sData;
        });
    },
    // infoForKeyName: (keyName) => {
    //     wpn2SchemaData['keysList'].find(x => x.key === keyName) ?? {}
    // },
    allKeys: (data) => {
        const allKeyNames = new Set();
        for (const group in data) {
            const keys = data[group]['keys'];
            if (keys != undefined) {
                const keyNames = keys.map(x => x.key);
                keyNames.forEach(x => allKeyNames.add(x));
            }
        }
        const allKeys = [];
        for (const keyName of allKeyNames) {
            const keyData = schemaData.dataForKeyName(keyName, data)
            if (keyData != undefined) {
                allKeys.push(keyData);
            }
        }
        return allKeys;
    },
    dataForKeyName: (name, data) => {
        for (const group in data) {
            const keys = data[group]['keys'];
            if (keys != undefined) {
                const keyData = keys.find(x => x.key == name);
                if (keyData != undefined) {
                    return keyData;
                }
            }
        }
        return null;
    }
};

export default schemaData;
